import { DocumentViewerModal } from "../../../features/beneficiary-document-reports/ui/DocumentViewerModal";
import { AlertManagementDetailHeader } from "./AlertManagementDetailHeader";
import { AlertManagementDocsList } from "./AlertManagementDocsList";
import { DetailBackButton, DetailBodyCol, DetailBodyRow, DetailObservationBox, DetailSectionCard, DetailSectionTitle, DetailViewRoot } from "./detail.styles";

export const AlertManagementVerView = ({
  record, pillMap, documents, detailLoading, detailData,
  onBack, onViewDocument, onDownloadDocument,
  pdfViewer, onClosePdfViewer, onDownloadFromViewer,
}) => (
  <DetailViewRoot>
    <DetailBackButton onClick={onBack}>Volver</DetailBackButton>
    <AlertManagementDetailHeader record={record} pillMap={pillMap} detailData={detailData} />
    <DetailBodyRow gutter={[16, 16]}>
      <DetailBodyCol xs={24} lg={13}>
        <AlertManagementDocsList
          documents={documents} loading={detailLoading}
          onView={onViewDocument} onDownload={onDownloadDocument}
        />
      </DetailBodyCol>
      <DetailBodyCol xs={24} lg={11}>
        <DetailSectionCard bordered={false}>
          <DetailSectionTitle>Resumen</DetailSectionTitle>
          <DetailObservationBox>
            <p style={{ margin: 0, color: "#0f172a", lineHeight: 1.6 }}>
              {detailData?.resumen || "Sin resumen disponible."}
            </p>
          </DetailObservationBox>
        </DetailSectionCard>
      </DetailBodyCol>
    </DetailBodyRow>
    <DocumentViewerModal
      isOpen={pdfViewer.isOpen} title="Visor de documento"
      subtitle={pdfViewer.title} documentUrl={pdfViewer.url}
      onClose={onClosePdfViewer} onDownload={onDownloadFromViewer}
    />
  </DetailViewRoot>
);